export default class SkipLogicItem {
  constructor(val) {
    this.skip_logic_id = val.id
    this.question = val.question
    this.question_type = val.question_type
    this.answer = val.answer
  }
}
